import {Dispatch} from "redux";

import {IFullCarDetailParams} from "../../../../../../packages/utils/cars_routes";
import {IStore} from "../../../app/reducers/hybrid_reducer";
import {IRouteState} from "../../../app/routes/data_fetcher/create_app_path_data_fetcher";
import {IServices} from "../../../app/services/IServices";
import {updateMetaData} from "../../../meta_data/actions/update_meta_data";
import {
    buildOfferCanonicalUrl,
    buildOfferMetaDescription,
    buildOfferMetaTitle,
    getOfferSeoImage
} from "../utils/build_offer_seo";

export const updateOfferMetaData =
    (_services: Partial<IServices>, route: IRouteState<IFullCarDetailParams>) =>
    (dispatch: Dispatch, getState: () => IStore) => {
        const car = getState().offer?.car?.data;
        if (!car?.id || !car.slug) {
            return Promise.resolve(false);
        }

        const title = buildOfferMetaTitle(car);
        const description = buildOfferMetaDescription(car);
        const url = buildOfferCanonicalUrl(car.slug);
        const image = getOfferSeoImage(car);

        dispatch(
            updateMetaData(title, description, route, {
                robots: "index, follow",
                canonical: url,
                url,
                image,
                maxImagePreview: "large"
            })
        );

        return Promise.resolve(true);
    };
